import { Button, ButtonProps, styled } from '@mui/material';

export const CustomButton = styled(Button)<ButtonProps & { padding?: string; backgroundColor?: string }>(({ theme, padding, variant, backgroundColor = '#30893C' }) => ({
  minWidth: 'fit-content',
  padding: padding ?? '12px',
  backgroundColor: variant === 'outlined' ? 'white' : backgroundColor,
  borderColor: variant === 'outlined' ? '#D0D5DD' : backgroundColor,
  textTransform: 'none',
  fontSize: '16px',
  borderRadius: '8px',
  fontWeight: 600,
  boxSizing: 'border-box',
  color: variant === 'outlined' ? '#D0D5DD' : 'white',

  '&:hover': {
    backgroundColor: variant === 'outlined' ? '#F9FAFB' : backgroundColor,
    borderColor: variant === 'outlined' ? '#98A2B3' : backgroundColor,
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: variant === 'outlined' ? '#F9FAFB' : backgroundColor,
    borderColor: variant === 'outlined' ? '#98A2B3' : backgroundColor,
  },
  '&:focus': {
    boxShadow: '0 0 0 0.1rem #fff',
  },
  '&:disabled': {
    color: variant === 'outlined' ? '#D0D5DD' : 'white',
    backgroundColor: variant === 'outlined' ? 'white' : backgroundColor,
    borderColor: variant === 'outlined' ? '#EAECF0' : backgroundColor,
    opacity: 0.6,
  },
}));
